var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.036 59.9971C120.036 26.86 93.1727 -0.00289806 60.0356 -0.00289845C26.8986 -0.00289885 0.0356456 26.86 0.0356452 59.9971C0.0356449 93.1342 26.8986 119.997 60.0356 119.997C93.1727 119.997 120.036 93.1342 120.036 59.9971Z",
    fill: "#A0C460"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7391 86.725C66.9565 92.8471 53.1141 92.8471 41.3244 86.725C39.3855 85.7164 38.6255 83.4863 39.5417 81.9735C40.4579 80.4536 42.4537 80.0559 44.0588 80.8869C54.1227 86.1142 65.9409 86.1142 76.0048 80.8869C77.617 80.0559 79.6056 80.4607 80.5218 81.9735C81.438 83.4863 80.6781 85.7164 78.7391 86.725Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9154 47.3429C47.9154 51.8244 44.7264 55.4608 40.7989 55.4608C36.8713 55.4608 33.6824 51.8244 33.6824 47.3429C33.6824 42.8613 36.8713 39.225 40.7989 39.225C44.7264 39.225 47.9154 42.8613 47.9154 47.3429Z",
    fill: "#939598"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3814 47.3429C86.3814 51.8244 83.1925 55.4608 79.2649 55.4608C75.3374 55.4608 72.1484 51.8244 72.1484 47.3429C72.1484 42.8613 75.3374 39.225 79.2649 39.225C83.1925 39.225 86.3814 42.8613 86.3814 47.3429Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8712 33.1738C38.2277 33.1951 34.6908 34.4238 31.8144 36.661C30.813 37.4352 29.3641 37.5204 28.4408 36.6823C27.5246 35.8514 27.7235 34.1468 29.0445 33.117C32.7022 30.269 37.205 28.7065 41.8428 28.6781C43.526 28.671 44.7334 29.8784 44.5274 31.0999C44.3286 32.3286 43.1283 33.1596 41.8712 33.1738Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1923 33.1738C81.8358 33.1951 85.3727 34.4238 88.2491 36.661C89.2505 37.4352 90.6994 37.5204 91.6227 36.6823C92.5389 35.8514 92.34 34.1468 91.019 33.117C87.3613 30.269 82.8585 28.7065 78.2207 28.6781C76.5375 28.671 75.3301 29.8784 75.5361 31.0999C75.7349 32.3286 76.9352 33.1596 78.1923 33.1738Z",
    fill: "#939598"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE4);
export default __webpack_public_path__ + "static/media/E4.346a9fda72e4693e9ec736ef728cf5d4.svg";
export { ForwardRef as ReactComponent };